import * as React from 'react';

/**
 * A page's header (the prototype's `header()`): eyebrow, serif title, a sentence under it, and
 * the page's controls on the right. The day arrows and the "As of" pill arrive with SHL-003.
 */
export function PageHeader({
  eyebrow,
  title,
  sub,
  right,
}: {
  readonly eyebrow: string;
  readonly title: string;
  readonly sub: string;
  readonly right?: React.ReactNode;
}): React.ReactElement {
  return (
    <header className="head">
      <div className="head-left">
        <span className="eyebrow">{eyebrow}</span>
        <h1 className="display">{title}</h1>
        <span className="sub">{sub}</span>
      </div>
      {right !== undefined ? <div className="head-right">{right}</div> : null}
    </header>
  );
}

/** A page whose content hasn't been built yet says so and names the story that builds it. */
export function NotBuiltYet({ story, what }: { readonly story: string; readonly what: string }): React.ReactElement {
  return (
    <section className="card pad stack" style={{ gap: 8 }}>
      <h2>Not built yet</h2>
      <span style={{ color: 'var(--ink-2)' }}>
        {what} arrives with {story}.
      </span>
    </section>
  );
}
